import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReeValidate from 'ree-validate';
import { resetPassword, verifyResetPasswordToken } from '../store/actions/auth';
import { validator } from '../validators';
import { convertReadbleFormat } from './../helpers';
import Footer from './Footer';
import Header from './Header';

validator(ReeValidate);
class ResetPassword extends Component {
	constructor(props) {
		super(props);
		this.validator = new ReeValidate({
			newPassword: 'required|min:6',
			confirmPassword: 'required',
		});
		this.state = {
			isValid: true,
			formData: {
				newPassword: '',
				confirmPassword: '',
			},
			confirmPassErr: '',
			formErrors: this.validator.errors,
		};
		this.verifyToken();
	}

	verifyToken = () => {
		const {
			verifyResetPasswordToken,
			match: {
				params: { resetPasswordToken = '' },
			},
		} = this.props;
		verifyResetPasswordToken(resetPasswordToken)
			.then(() => this.setState({ isValid: true }))
			.catch(() => this.setState({ isValid: false }));
	};

	handleChange = e => {
		const name = e.target.name;
		const value = e.target.value;
		const { formErrors } = this.state;
		this.setState(
			{ formData: { ...this.state.formData, [name]: value } },
			() => {
				this.validateConfirmPassword();
			}
		);
		formErrors.remove(name);

		this.validator.validate(name, value).then(() => {
			this.setState({ formErrors });
		});
	};

	validateConfirmPassword() {
		const { newPassword, confirmPassword } = this.state.formData;
		let { confirmPassErr } = this.state;
		if (newPassword && confirmPassword) {
			if (confirmPassword !== newPassword) {
				confirmPassErr = 'Confirm Password does not match';
			} else {
				confirmPassErr = '';
			}
		}
		this.setState({ confirmPassErr });
	}

	resetPassword = e => {
		e.preventDefault();
		const {
			resetPassword,
			history,
			match: {
				params: { resetPasswordToken = '' },
			},
		} = this.props;
		const { formData } = this.state;
		const { errors } = this.validator;
		this.validateConfirmPassword();
		if (!this.state.confirmPassErr) {
			this.validator.validateAll(formData).then(success => {
				if (success) {
					resetPassword(resetPasswordToken, formData.newPassword).then(() =>
						history.push('/')
					);
				} else {
					this.setState({ formErrors: errors });
				}
			});
		}
	};

	renderMessage() {
	const {
		currentUser: { isAuthenticated },
	} = this.props;
    if (isAuthenticated) {
      return (
        <div className="text-center">
          <h3>Already Logged In!</h3>
          <p>
            It seems you are already logged in. Please log out first and try
            again.
				</p>
        </div>
      )
    } else {
      return (
        <div className="text-center">
          <h3>Link Expired</h3>
          <p>
            You have already changed the password. Please try again with the new
            link.
				</p>
        </div>
      );
    }
	}

	render() {
		const {
			isValid,
			formErrors,
			confirmPassErr,
			formData: { newPassword, confirmPassword },
		} = this.state;
		const {
			currentUser: { isAuthenticated },
		} = this.props;
		return (
			<Fragment>
				<Header {...this.props} />
				<div
					className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed"
					style={{ height: 'calc(100vh - 175px)' }}
				>
					<div className="container">
						<div className="row">
							<div
								className="content-box video-popup"
								style={{ paddingBottom: '30px' }}
							>
								<div className="col-md-6 col-md-offset-3 contact-form">
									<div className="content">
										<h1>Reset Password</h1>
									</div>
								</div>
							</div>
						</div>
					</div>

          <div id="contact" className="contact-us-area">
            <div className="container">
              {!isAuthenticated && isValid &&
                <div className="row">
                  <div className="col-md-12 contact-form">
                    <form action="#" method="POST" className="contact-form" onSubmit={this.resetPassword} noValidate>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="form-group">
                            <input className="form-control" id="newPassword"
                              name="newPassword" placeholder="New Password" type="password"
                              value={newPassword} onChange={this.handleChange} />
                            {formErrors.has('newPassword') &&
                              <span className="error text-danger">{convertReadbleFormat(formErrors.first('newPassword'))}</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="form-group">
                            <input className="form-control" id="confirmPassword"
                              name="confirmPassword" placeholder="Confirm Password"
                              type="password" value={confirmPassword} onChange={this.handleChange} />
                            {(formErrors.has('confirmPassword') || confirmPassErr) &&
                              <span className="error text-danger">{(formErrors.has('confirmPassword')
                                && convertReadbleFormat(formErrors.first('confirmPassword'))) || confirmPassErr}</span>
                            }
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <button type="submit" name="submit" id="submit">
                              Reset <i className="fa fa-paper-plane"></i>
                            </button>
                          </div>
                        </div>
                        <div className="col-md-12 alert-notification">
                          <div id="message" className="alert-msg"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              }
              {!isAuthenticated && !isValid && <div className="text-center">
                    <h3>Link Expired</h3>
                    <p>You have already changed the password. Please try again with the new link.</p>
                  </div>
              }
              { isAuthenticated && <div className="text-center">
                    <h3>Already Logged In!</h3>
                    <p>It seems you are already logged in. Please log out first and try again.</p>
                  </div>
              }
            </div>
          </div>
        </div>
        <Footer {...this.props} />
      </Fragment>
    )
  }
}

export default connect(null, { verifyResetPasswordToken, resetPassword })(
	ResetPassword
);



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js